export function capitalize(string) {
  if (!string) return string;
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}
export function getStatusColor(status) {
  const lowerCaseStatus = status?.toLowerCase();

  switch (lowerCaseStatus) {
    case "pending":
      return "rgba(136, 77, 255, 1)";
    case "success":
      return "rgba(4, 153, 151, 1)";
    case "failed":
      return "rgba(255, 69, 58, 1)"; // Chosen color for 'failed' status
    default:
      return "rgba(136, 77, 255, 1)"; // Default color for unknown statuses
  }
}
